import {
    Component, EventEmitter, Input, Output
} from "@angular/core";

export type SigningFlowOption = "Vendor" | "Reviewer" | "Both";

@Component({
    selector: "app-signing-flow-dialog",
    templateUrl: "./signing-flow-dialog.component.html",
    styleUrl: "./signing-flow-dialog.component.scss"
})
export class SigningFlowDialogComponent {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() selectionConfirmed = new EventEmitter<SigningFlowOption>();

    selectedFlow: SigningFlowOption | null = null;

    selectFlow(flow: SigningFlowOption) {
        this.selectedFlow = flow;
    }

    onConfirm() {
        if (this.selectedFlow) {
            this.selectionConfirmed.emit(this.selectedFlow);
            this.closeDialog();
        }
    }

    onCancel() {
        this.closeDialog();
    }

    closeDialog() {
        this.selectedFlow = null;
        this.visible = false;
        this.visibleChange.emit(false);
    }

    isSelected(flow: SigningFlowOption): boolean {
        return this.selectedFlow === flow;
    }
}
